// Recat Component
import { configureStore, combineReducers } from "@reduxjs/toolkit"
import { useDispatch, useSelector } from "react-redux"
import type { TypedUseSelectorHook } from "react-redux"
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

// My Slices
import authReducer from "./slices/authSlice"
import userReducer from "./slices/userSlice"
import roleReducer from "./slices/roleSlice"
import mapIdReducer from "./slices/mapIdSlice"
import companyReducer from "./slices/companySlice"

const persistConfig = {
    key: 'root',
    storage,
}

const rootReducer = combineReducers({
    auth: authReducer,
    user: userReducer,
    role: roleReducer,
    company: companyReducer,
    mapId: mapIdReducer
})

const persistedReducer = persistReducer(persistConfig, rootReducer) as unknown as typeof rootReducer

const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: {
            ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
    }),
})
export default store

export const persistor = persistStore(store)

export const useAppDispatch: () => typeof store.dispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<
    ReturnType<typeof store.getState>
> = useSelector